import { useState, useEffect } from 'react';
import {
  getReporteVentasCortesiasTipo,
  VentaCortesiaTipoRow,
} from '../../../../service/reportes/VentasCortesiasTipo';

export function useReporteVentasCortesiasTipo(ids_dia: number[]) {
  const [list, setList] = useState<VentaCortesiaTipoRow[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (ids_dia.length === 0) {
      setList([]);
      return;
    }
    setLoading(true);
    getReporteVentasCortesiasTipo(ids_dia)
      .then(setList)
      .catch(() => setList([]))
      .finally(() => setLoading(false));
  }, [ids_dia.join(',')]); // eslint-disable-line react-hooks/exhaustive-deps

  return { list, loading };
}
